// Copyright (c) 2016 Deere & Company

import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import t from 'tcomb';

const Branches = t.list(KeyValuePair, 'Branches');

export const getDefaultState = () => new Branches([]);

export default Branches;



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/state/branches.js